/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const CloudDownloadIcon = /*#__PURE__*/ createSvgIcon(
  'CloudDownloadIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.638 1.5a3.82 3.82 0 013.793 3.019c.688.062 1.38.277 1.939.713.694.541 1.129 1.381 1.13 2.523a2.95 2.95 0 01-2.71 2.993l-.02.002h-1.52v-1h1.478A1.95 1.95 0 0013.5 7.77v-.01c0-.865-.315-1.404-.745-1.74-.45-.35-1.079-.52-1.755-.52h-.454l-.044-.452A2.82 2.82 0 007.64 2.5h-.035A3.1 3.1 0 004.35 5.562V6.5h-.62l-.02-.002a1.13 1.13 0 00-1.212 1.234l.002.024V9.75h3.25v1H1.5V7.802a2.13 2.13 0 011.85-2.29A4.1 4.1 0 017.639 1.5zM7.5 12.793V6h1v6.793l1.146-1.147.708.708L8 14.707l-2.354-2.353.708-.708L7.5 12.793z"
            fill="currentColor"
          />
        </>
      ),
      medium: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.515 1.5a4.93 4.93 0 014.92 4.015c.936.064 1.875.343 2.623.926.881.687 1.44 1.757 1.442 3.234a3.77 3.77 0 01-3.459 3.823l-.02.002H13v-1h1.979A2.77 2.77 0 0017.5 9.69v-.01c0-1.2-.44-1.969-1.058-2.45-.636-.497-1.516-.73-2.442-.73h-.454l-.044-.452A3.93 3.93 0 009.52 2.5H9.49a4.31 4.31 0 00-4.48 4.244V7.83h-.69l-.019-.002a1.68 1.68 0 00-1.803 1.827l.002.022V12.5H7v1H1.5V9.721a2.68 2.68 0 012.51-2.893v-.095A5.31 5.31 0 019.515 1.5zM9.5 16.793V7h1v9.793l2.146-2.147.708.708L10 18.707l-3.354-3.353.708-.708L9.5 16.793z"
            fill="currentColor"
          />
        </>
      ),
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.39 1.5c3.13.005 5.79 2.442 6.083 5.104 1.174.073 2.349.42 3.276 1.157 1.068.849 1.75 2.17 1.751 4.012a4.62 4.62 0 01-4.205 4.725l-.023.002H16v-1h2.227a3.62 3.62 0 003.273-3.706v-.014c0-1.574-.568-2.596-1.374-3.236-.823-.655-1.952-.954-3.126-.954h-.5v-.5c0-2.233-2.285-4.59-5.12-4.59h-.02a5.55 5.55 0 00-5.78 5.502V9.26h-.678l-.018-.001a2.24 2.24 0 00-2.387 2.485l.003.028V15.5H8v1H1.5v-4.673a3.24 3.24 0 013.08-3.571v-.26A6.55 6.55 0 0111.39 1.5zm.11 19.293V8h1v12.793l3.146-3.147.708.708L12 22.707l-4.354-4.353.708-.708 3.146 3.147z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default CloudDownloadIcon;
